<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="category_id" size="small" placeholder="请选择" clearable>
                            <el-option v-for="item  in type_options" :key="item.id" :label="item.text" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="question_paper_name" label="问卷名称" show-overflow-tooltip width="300">
                </el-table-column>
                <el-table-column prop="detailarr" label="问卷评分描述" show-overflow-tooltip>
                    <!-- <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" placement="top-start">
                            <div slot="content" style="white-space: pre-line;">
                                {{scope.row.detailarr}}</div>
                            <div>{{scope.row.detailarr}}</div>
                        </el-tooltip>
                    </template> -->
                </el-table-column>
                <el-table-column label="问题模块" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handlelookqu(scope.$index, scope.row)">查看
                        </el-button>

                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column label="操作" width="260">
                    <template slot-scope="scope">
                        <el-button size="mini" type="info" v-if="!scope.row.top_time" @click="handle_top(scope.row,1)">
                            置顶
                        </el-button>
                        <el-button size="mini" type="primary" v-else plain @click="handle_top(scope.row,0)">取消置顶
                        </el-button>
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!--  -->
        <el-dialog title="问卷设置" :visible.sync="dialogs" top="80px" width="50%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-loading='editloading'>
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-row>
                        <el-form-item label="类型">
                            <el-radio-group v-model="form.category_id">
                                <el-radio :label="1">心理健康自测</el-radio>
                                <el-radio :label="2">身体健康自测</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="位置">
                            <el-radio-group v-model="form.type">
                                <el-radio :label="1">全部</el-radio>
                                <el-radio :label="2">身体健康自测</el-radio>
                                <el-radio :label="3">心理健康自测</el-radio>
                                <el-radio :label="4">禁用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="问卷名称" prop="name">
                            <el-input placeholder="请输入内容" size='small' v-model="form.name"> </el-input>
                        </el-form-item>
                        <el-form-item label="问卷描述" prop="content">
                            <el-input type="textarea" :rows="2" placeholder="请输入" v-model="form.content">
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="'评分'+(ind+1)" v-for="(o,ind) in form.answers" :key="ind"
                            style="margin-top:15px" required>
                            <el-row :gutter="10">
                                <el-col :span="20">
                                    <el-input type="textarea" :rows="2" placeholder="请输入" v-model="o.name">
                                    </el-input>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :span="20">
                                    分数范围
                                    <el-input v-model="o.pstart" style="width:50px" size="mini"></el-input>-
                                    <el-input v-model="o.pend" style="width:55px" size="mini"></el-input>
                                    <span class="btn">
                                        <el-button size="mini" type="success" @click="addpro(o)">添加</el-button>
                                        <el-button size="mini" v-if="ind!=0" type="danger" @click="delpro(o)">删除
                                        </el-button>
                                    </span>
                                </el-col>
                            </el-row>
                            <div style="color:red" v-if="ind==form.answers.length-1">结果与结果描述用“;”(英文分号)隔开</div>
                        </el-form-item>
                        <el-form-item label="上传" required>
                            <el-upload class="upload-demo" action="/admin/image/upload" name="img" ref="upload"
                                :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'71' }"
                                :file-list="form.fileList" :on-success="uploadSuccess" :limit='1'
                                :on-preview="handlePrev">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div class="el-upload__tip" slot="tip">只能上传一张图片</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading='subloading' @click="submit('form')" size="small">确 定
                            </el-button>
                            <el-button @click="dialogs = false" size="small">取 消</el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>
        <!-- 问题-->
        <el-dialog title="问题设置" :visible.sync="contentvotedetail" top="50px" width="60%" class="dialogs">
            <el-divider></el-divider>
            <Contentvotelist ref="votelist" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="contentvotedetail=false" size="small">确定</el-button>
            </span>
        </el-dialog>

        <!-- 预览图片 -->
        <el-dialog :visible.sync="previewModel" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="previewUrl" class="w-100" />
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import Contentvotelist from "./problems.vue";
    export default {
        components: {
            Contentvotelist
        },
        data() {
            return {
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                mtheights: {
                    height: null,
                    "overflow": "auto",
                },

                // 
                NumList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'],
                eid: '',
                props: {
                    label: 'problem',
                    children: 'children'
                },
                wt_options: [],
                dialogs: false,
                form: {
                    name: '',
                    category_id: 2,
                    wjxx: [],
                    detail: '',
                    content: '',
                    fileList: [],
                    answers: [{
                        name: "",
                        pstart: '',
                        pend: ''
                    }],
                    type:1
                },
                rule: {
                    name: [{
                        required: true,
                        message: '问卷名称不能为空'
                    }],
                    content: [{
                        required: true,
                        message: '请输入描述'
                    }],

                },
                fileListed: [],
                previewModel: false,
                previewUrl: '',
                contentvotedetail: false,
                editloading: false,

                subloading: false,
                type_options: [{
                        id: 1,
                        text: '心理健康自测'
                    },
                    {
                        id: 2,
                        text: '身体健康自测'
                    },
                ],
                category_id: '',

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getxx()
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                that.mtheights.height = window.innerHeight - 360 + 'px'

                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                    that.mtheights.height = window.innerHeight - 360 + 'px'

                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/questionTestPaper/list", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        keyword: that.titles,
                        category_id: this.category_id
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list

                        that.tableData.forEach(ele => {
                            if (ele.detail) {
                                let detailarr = []
                                ele.detail.forEach(e => {
                                    detailarr.push(e.name)
                                })
                                ele.detailarr = detailarr.toString()
                            }
                        })
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },

            // 新增
            add() {
                let that = this
                that.dialogs = true
                that.eid = '0'
                that.clear()
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (that.fileListed.length == 0) return this.$message.error('请上传图片')
                        let ansnull = false
                        this.form.answers.forEach(e => {
                            if (!e.name || !e.pstart || !e.pend) {
                                ansnull = true
                                return
                            }
                        })
                        if (ansnull) return this.$message.error('请填写完整')
                        let urls;
                        if (that.eid && that.eid != '0') {
                            urls = "/admin/questionTestPaper/update"
                        } else {
                            urls = "/admin/questionTestPaper/save"
                        }
                        that.subloading = true
                        axios
                            .post(`${urls}`, {
                                id: that.eid,
                                question_paper_name: that.form.name,
                                category_id: that.form.category_id,
                                content: that.form.content,
                                detail: that.form.answers,
                                // question_problem_ids: that.form.wjxx.toString(),
                                // author: that.user.id,
                                background_image: that.fileListed,
                                type:this.form.type
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogs = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                                that.subloading = false
                            })
                            .catch(error => {
                                that.subloading = false

                            })
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            handle_top(row, val) {
                axios
                    .post("/admin/questionTestPaper/top", {
                        id: row.id,
                        top_time: val
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                            this.search()
                        } else {
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error => {})
            },
            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.clear()
                this.editloading = true
                axios
                    .post("/admin/questionTestPaper/read", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        this.editloading = false
                        if (data) {
                            // that.form.wjxx = (data.question_problem_ids.split(',')).map(Number)
                            // that.form.answers = data.detail
                            if (!data.detail) {
                                that.form.answers = [{
                                    name: "",
                                    pstart: '',
                                    pend: ''
                                }]
                            } else {
                                that.form.answers = data.detail
                            }
                            that.form.name = data.question_paper_name
                            that.form.category_id = data.category_id
                            that.form.content = data.content
                            that.form.fileList = data.background_image
                            that.form.type = data.type
                            that.fileListed = data.background_image

                        } else {
                            that.eid = ''
                        }
                    })
                    .catch(error => {})
            },
            handlelookqu(index, row) {
                this.contentvotedetail = true
                this.$nextTick(() => {
                    this.$refs.votelist.textId = row.id
                    this.$refs.votelist.getlist(row.id)
                    // this.$refs.votelist.votelist=row.content
                })
            },
            handleDelete(index, row) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/questionTestPaper/del", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.search()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            clear() {
                let that = this
                that.form.name = ''
                that.form.category_id = 2
                that.form.xxList = []
                that.form.detail = ''
                that.form.content = ''
                that.form.type= 1
                that.form.fileList = []
                that.fileListed = []
                that.form.answers = [{
                    name: "",
                    pstart: '',
                    pend: ''
                }]
            },
            // 获取选项
            getxx() {
                let that = this
                axios
                    .post("/admin/questionProblem/problemList", {}, {
                        token: true
                    })
                    .then(response => {
                        that.wt_options = response.data.data
                    })
                    .catch(error => {})
            },
            // 
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.message)
                    return;
                }
                that.fileListed = []
                that.fileListed.push(response.data)
            },
            handlePrev(file) {
                this.previewModel = true
                this.previewUrl = file.url
            },
            addpro(p) {
                this.form.answers.push({
                    name: "",
                    pstart: '',
                    pend: ''
                })
            },
            delpro(item) {
                var index = this.form.answers.indexOf(item)
                if (index !== -1) {
                    this.form.answers.splice(index, 1)
                }
            },
        },

    };
</script>


<style scoped>
    .mr_ck {
        margin: 10px 0;
    }

    .f_w {
        font-weight: 600;
    }

    .bds {
        border-bottom: 1px solid #f5f5f5
    }

    .btn {
        margin-left: 20px;
    }
</style>